import { countriesList, countryCodeToFlagEmoji } from "../components/Account/Countries";

/** Map session `country` (ISO code or full name) to select value (always code). */
export function countryToSelectValue(stored: string | undefined): string {
  const t = stored?.trim() ?? "";
  if (!t) return "";
  if (countriesList.some((c) => c.code === t)) return t;
  const row = countriesList.find((c) => c.country.toLowerCase() === t.toLowerCase());
  return row?.code ?? t;
}

/** Flag emoji for profile overlays when country is a known ISO code; otherwise "". */
export function getProfileCountryFlagEmoji(stored: string | undefined): string {
  const code = countryToSelectValue(stored);
  if (!code || !countriesList.some((c) => c.code === code)) return "";
  return countryCodeToFlagEmoji(code);
}
